// extracted by mini-css-extract-plugin
export default {"main":"Yda-z"};